import React from 'react';
import { useDispatch, useSelector } from 'react-redux'; // Ajout de useDispatch
import { stopConference } from '../../../ControlPanel/store/Conference/ConferenceThunks';
import './StopConferenceModal.css'
import { DELETE_RESERVATION } from '../../../ControlPanel/store/AddEvent/AddEventSlice';
import { FIRE_GUESTS } from '../../../Map/store/Avatars/AvatarsSlice';
import { getConferenceUserParams } from '../../../../utils/conferenceUtils';

const StopConferenceModal = ({ onClose }) => {
    const dispatch = useDispatch();

    const { conference, uiState } = useSelector((state) => state.activeConference);
    const conferenceId = conference?.id;
    const avatarsData = useSelector((state) => state.avatars?.avatars || {});
    const { localAvatar } = useSelector((state) => state.auth);

    const { externalGuestEmails } = getConferenceUserParams(
        conference,
        avatarsData,
        localAvatar,
        uiState.is_conference_active
  );
    const handleStopConference = () => {
        if (!conferenceId) return;

        dispatch(
            stopConference({
                body: {
                    conferenceId: conferenceId,
                },
            })

        ).unwrap();
        dispatch(FIRE_GUESTS({
            avatarsEmails: externalGuestEmails,
        }))
        dispatch(DELETE_RESERVATION({ bookingId: conferenceId }));

        onClose();
    };

    return (
        <div className="stop-conference-pannel">
            <div className="stop-conference-text">
                <p>
                    Vous êtes sur le point de terminer la conférence en cours. Lorsque vous terminerez la conférence,
                    l'ensemble des invités seront déconnectés automatiquement de la salle et les internes restants
                    se retrouveront dans une réunion classique.
                </p>
                <br />
                <p>Souhaitez-vous continuer ?</p>
            </div>


            <div className="stop-conference-buttons">
                <button
                    type="button"
                    onClick={onClose}
                    className="stop-conference-cancel"
                >
                    Annuler
                </button>
                <button
                 type="button"
                   onClick={handleStopConference}
                    className="stop-conference-confirm"
                >
                    Terminer la conférence
                </button>
            </div>
        </div>
    );
};

export default StopConferenceModal;